module.exports = __webpack_public_path__ + "static/img/four.a9cf132.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partTimePackage/four.png
// module id = XBF1
// module chunks = 1